import { jsx } from "react/jsx-runtime";
import { FieldActionsContext } from "../../../../contexts/field-actions-context.js";
import { FieldValidationContext } from "../../../../contexts/field-validation-context.js";
import { FormContext } from "../../../../contexts/form-context.js";
import { FormValuesContext } from "../../../../contexts/form-values-context.js";
import { FormViewContext } from "../../../../contexts/form-view-context.js";
import { FormFieldsContext } from "../../contexts/form-fields-context.js";
import { FormField } from "./form-field.js";
const createFormFields = ({
  form,
  errors,
  values,
  onFieldChange,
  onBlur,
  onFocus,
  FieldLayout,
  formSchema,
  validateFields,
  fields,
  fieldActions
}) => {
  return form.fields.map((formField) => {
    const component = /* @__PURE__ */ jsx(FormContext.Provider, { value: formSchema, children: /* @__PURE__ */ jsx(FormFieldsContext.Provider, { value: fields, children: /* @__PURE__ */ jsx(FieldActionsContext.Provider, { value: fieldActions, children: /* @__PURE__ */ jsx(FieldValidationContext.Provider, { value: { validateFields }, children: /* @__PURE__ */ jsx(FormViewContext.Provider, { value: form, children: /* @__PURE__ */ jsx(FormValuesContext.Provider, { value: values, children: /* @__PURE__ */ jsx(
      FormField,
      {
        field: formField,
        values,
        errors,
        onBlur,
        onFocus,
        onFieldChange,
        FieldLayout
      },
      formField.id
    ) }) }) }) }) }) });
    return {
      id: formField.id,
      fieldType: formField.fieldType,
      component,
      layout: formField.layout
    };
  }).filter((item) => !!item);
};
export {
  createFormFields
};
//# sourceMappingURL=create-form-fields.js.map
